import { Injectable } from '@angular/core';
import axios from 'axios';
import { HttpClientService } from './http-client.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerServiceInsightsRequestsService {
  private ENDPOINT_BASE_PATH: string = '/customer-service-insights';

  constructor(
    private _httpClientService: HttpClientService
  ) { }

 /** Locations Performance Count Data API Call
    Page Name: Overview & Location Details Page
    Section: Location Performance & Observations
  **/
  async getLocationsPerformanceData(region: string, period: string, accountNumber: string | null, accountNumbersAdvancedFilters:string[] | null) {

    try {
      if (period == undefined) {
        throw new Error('Period is undefined');
      }

      let url = `${this.ENDPOINT_BASE_PATH}/location-performance?region=${region}&period=${period}`;
      if (accountNumber) {
        url += `&accountNumber=${accountNumber}`;
      }
      let payload = {accountNumbers:accountNumbersAdvancedFilters};

      return await this._httpClientService.post(
        url, payload
      );
    } catch (error) {
      console.error('Error fetching data:', error);
      return axios('fail');
    }
  }

  /** Locations Issues Count Data API Call
    Page Name: Overview & Location Details Page
    Section: Observations
  **/
  async getIssuesCountData(region: string, period: string, accountNumber: string | null, accountNumbersAdvancedFilters:string[] | null) {

    try {
      if (period == undefined) {
        throw new Error('Period is undefined');
      }

      let url = `${this.ENDPOINT_BASE_PATH}/issue-counts?region=${region}&period=${period}`;
      if (accountNumber) {
        url += `&accountNumber=${accountNumber}`;
      }
      let payload = {accountNumbers:accountNumbersAdvancedFilters};

      return await this._httpClientService.post(
        url, payload
      );

    } catch (error) {
      console.error('Error fetching data:', error);
      return axios('fail');
    }
  }

  /** Total Calls Count By Type Data API Call
    Page Name: Overview Page
    Section: Observations
  **/
    async getTotalCallsByTypeData(region: string, period: string, accountNumbersAdvancedFilters:string[] | null) {

      try {
        if (period == undefined) {
          throw new Error('Period is undefined');
        }
        let payload = {accountNumbers:accountNumbersAdvancedFilters};

        return await this._httpClientService.post(
          `${this.ENDPOINT_BASE_PATH}/calls-by-type?region=${region}&period=${period}`,
          payload
        );

      } catch (error) {
        console.error('Error fetching total calls by type data:', error);
        return axios('fail');
      }
    }

  /** Locations Insights Data API Call
      Page Name: Overview page
      Section: Top/Bottom Locations Insights
  **/
  async getLocationInsightsData(region: string, period: string, accountNumbersAdvancedFilters: string[] | null) {
    try{
      if (period == undefined) {
        throw new Error('Period is undefined');
      }
      let payload = {accountNumbers:accountNumbersAdvancedFilters};

      return await this._httpClientService.post(
        `${this.ENDPOINT_BASE_PATH}/locationsInsights?region=${region}&period=${period}`,
        payload
      );
    }catch(error){
      console.error('Error fetching data:', error);
      return axios('fail');
    }
  }

  /** Locations Insights Data API Call
      Page Name: Overview page
      Section: Top/Bottom Locations Insights
  **/
  async getLocationDetailsData(region: string, period: string, accountNumber: string | null, pageNumber: number, pageSize: number, graphDetailFilter: string | undefined) {
    if (period == undefined || accountNumber == null) {
      throw new Error('Period or Account Number is undefined');
    }

    const payload = { graphDetailFilter };

    try{
      return await this._httpClientService.post(
        `${this.ENDPOINT_BASE_PATH}/location-details?region=${region}&period=${period}&accountNumber=${accountNumber}&page=${pageNumber}&limit=${pageSize}`,
        payload
      );
    } catch(error){
      console.error('Error fetching data:', error);
      return axios('fail');
    }
  }
}
